/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as Msdyn365 from '@msdyn365-commerce/core';
import { getPayloadObject, getTelemetryAttributes, ITelemetryContent, onTelemetryClick } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICoreContext } from '@msdyn365-commerce/core';
import { ILinksData } from '../dobbies-content-block.props.autogenerated';
import { IDobbiesContentBlockData } from '../dobbies-content-block.data';
import { ShowCookieManageModalInput } from '../../../actions/show-cookie-dialog-state';
import { RichText } from '@msdyn365-commerce/core';
export interface IContentCardLinks {
    links: ILinksData[];
    requestContext: Msdyn365.IRequestContext;
    telemetryContent: ITelemetryContent;
    role?: string;
    context: ICoreContext;
    showLoyaltyBoltonDialog?(msg: string | Msdyn365.RichText): void;
    data?: IDobbiesContentBlockData;
    alreadyPurchasedBoltonsMsg?: string;
    clubPlusPurchasedMsg?: RichText;
    isShowCookiesManageModal?: boolean;
    shouldShowLoyaltyBoltonDialog?: boolean;
    currentUserTierId?: string;
    onTextChange?(index: number): (event: Msdyn365.ContentEditableEvent) => void;
}

/**
 *
 * ContentCardLinks component.
 * @extends {React.PureComponent<IContentCardLinks>}
 */
export class ContentCardLinks extends React.PureComponent<IContentCardLinks> {
    public render(): JSX.Element {
        const editableLinks = this._mapEditableLinks(this.props.links);
        return (
            <div className='ms-content-block__cta'>
                {editableLinks && editableLinks.length > 0 ? (
                    <Msdyn365.Links
                        links={editableLinks}
                        editProps={{ onTextChange: this.props.onTextChange, requestContext: this.props.requestContext }}
                    />
                ) : null}
            </div>
        );
    }

    // private redirectToSignin = () => {
    //     const signInUrl = `${this.props.context.actionContext.requestContext.url.requestUrl.origin}/_msdyn365/signin`;
    //     window.location.href = signInUrl;
    // };

    private readonly _mapEditableLinks = (linkdata: ILinksData[]): Msdyn365.ILinksData[] | null => {
        if (!linkdata || linkdata.length === 0) {
            return null;
        }
        const editableLinks: Msdyn365.ILinksData[] = [];
        linkdata.forEach((link, index) => {
            // Construct telemetry attribute to render
            const payLoad = getPayloadObject('click', this.props.telemetryContent, '', '');
            const linkText = link.linkText ? link.linkText : '';
            payLoad.contentAction.etext = linkText;
            const attributes = getTelemetryAttributes(this.props.telemetryContent, payLoad);
            const btnClass = index === 0 ? 'msc-cta__primary' : 'msc-cta__secondary';
            const editableLink: Msdyn365.ILinksData = {
                ariaLabel: link.ariaLabel,
                className: btnClass,
                linkText: link.linkText,
                linkUrl: link.linkUrl.destinationUrl,
                openInNewTab: link.openInNewTab,
                role: this.props.role,
                additionalProperties: attributes,
                onClick: event => {
                    if (this.props.isShowCookiesManageModal) {
                        this.props.context?.actionContext.update(new ShowCookieManageModalInput(), {
                            showCookieManageModal: true
                        });
                        return;
                    }
                    if (this.props.shouldShowLoyaltyBoltonDialog) {
                        const isAuthenticated = this.props.context.request.user.isAuthenticated;
                        // if (!isAuthenticated) {
                        //     event.preventDefault();
                        //     this.redirectToSignin();
                        //     return;
                        // }
                        const url = window.location.href;
                        const splittedUrl = url.split('/');
                        if (splittedUrl && splittedUrl.length) {
                            const urlPath = splittedUrl[splittedUrl.length - 1];
                            this.props.context.request.cookies.set('boltons_url_path', urlPath);
                        }
                        const boltonAttr = this.props.data?.customerInformation.result?.Attributes?.find(
                            attr => attr.Name?.toLowerCase() === 'IsBoltonMember'.toLowerCase()
                        );
                        if (boltonAttr && boltonAttr.AttributeValue?.StringValue === 'Yes' && this.props.showLoyaltyBoltonDialog) {
                            const msg = this.props.alreadyPurchasedBoltonsMsg
                                ? this.props.alreadyPurchasedBoltonsMsg
                                : 'You’ve already purchased Club Plus Double Up with this account';
                            this.props.showLoyaltyBoltonDialog(msg);
                            event.preventDefault();
                            return;
                        } else {
                            if (
                                isAuthenticated &&
                                ((!this.props.currentUserTierId && this.props.showLoyaltyBoltonDialog) ||
                                    (this.props.currentUserTierId === 'Club' && this.props.showLoyaltyBoltonDialog))
                            ) {
                                const msg = this.props.clubPlusPurchasedMsg
                                    ? this.props.clubPlusPurchasedMsg
                                    : 'This offer is for Club Plus only. If you have recently upgraded, please allow up to an hour for your account to update. Club Plus Double Up will then be available to purchase. If you’re Club member, you can upgrade here: Club | Dobbies Garden Centres';
                                this.props.showLoyaltyBoltonDialog(msg);
                                event.preventDefault();
                                return;
                            }
                            const cookie = this.props.context.request.cookies.get('club_plus_purchased');
                            if (cookie && (cookie.value === true || cookie.value === 'true') && this.props.showLoyaltyBoltonDialog) {
                                const msg = this.props.clubPlusPurchasedMsg
                                    ? this.props.clubPlusPurchasedMsg
                                    : 'This offer is for Club Plus only. If you have recently upgraded, please allow up to an hour for your account to update. Club Plus Double Up will then be available to purchase. If you’re Club member, you can upgrade here: Club | Dobbies Garden Centres';
                                this.props.showLoyaltyBoltonDialog(msg);
                                event.preventDefault();
                                return;
                            }
                        }
                    }
                    onTelemetryClick(this.props.telemetryContent, payLoad, linkText);
                }
            };
            editableLinks.push(editableLink);
        });

        return editableLinks;
    };
}
export default ContentCardLinks;
